import CircularProgress from "@material-ui/core/CircularProgress";
import * as React from "react";

class LoadingIcon extends React.Component<{}, {}> {
  public render() {
    return (
      <div className="loading-icon">
        <CircularProgress />
      </div>
    );
  }
}

export default LoadingIcon;
